// Stamp our outbound booking links with campaign attribution.
//
// Booking completes on a third-party domain (booksalon.dk / Timma). Appending
// utm_* + a salon_id lets that system - if it surfaces analytics - attribute a
// completed booking back to the website. Campaign params only: no personal
// data, nothing that re-identifies a visitor.

export function stampBookingUrl(url: string, salonId: string): string {
  try {
    const u = new URL(url)
    u.searchParams.set('utm_source', 'helinhair')
    u.searchParams.set('utm_medium', 'website')
    u.searchParams.set('utm_campaign', 'book')
    if (salonId) u.searchParams.set('utm_content', salonId)
    return u.toString()
  } catch {
    // Malformed URL - never block the booking; hand back the original.
    return url
  }
}
